import { defineStore } from 'pinia'
import { ref } from 'vue'
import { usePromiseLoader } from '@/composables/UsePromiseLoader.composables'
import { getActionsInReviewCount } from '@/contexts/actions/Actions.services'

export const useActionsInReviewStore = defineStore('actions-in-review', () => {
  const { isLoading, execute } = usePromiseLoader()

  const count = ref(0)
  const hasLoadedOnce = ref(false)

  const refresh = async () => {
    const { ok, data } = await execute(getActionsInReviewCount())
    count.value = ok ? data : 0
    hasLoadedOnce.value = true
  }

  return { count, isLoading, hasLoadedOnce, refresh }
})
